import {
  Button,
  Fade,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { enqueueSnackbar } from "notistack";
import { Update_Account_Info } from "../../DAL/Listing/AgencyAddAcount";
import { useAdminContext } from "../../Hooks/AdminContext";

export const AgencyAccountDetails = ({
  rowData,
  setRowData,
  setUserList,
  userList,
}) => {
  const { socket } = useAdminContext();
  const [loading, setLoading] = useState(false);
  const [modal, stOpenModal] = useState(false);
  const [inputs, setInputs] = useState({
    account_name: "",
    // facebook_page_link: "",
    // instagram_page_link: "",
    // tiktok_page_link: "",
    // twitter_page_link: "",
    // youtube_page_link: "",
    // linkedin_page_link: "",
    // snapchat_page_link: "",
    // pinterest_page_link: "",
    // website_link: "",
    // other_link: "",
    // other_link_name: "",
    // other_link_url: "",
  });

  const handleCloseModal = () => {
    setInputs({
      account_name: "",
    });
    stOpenModal(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const indexToInsert = userList?.findIndex(
      (item) => item?._id === rowData?._id
    );
    console.log(indexToInsert, "indexToInsert");
    setLoading(true);
    const data = {
      account_name: inputs?.account_name,
    };
    const response = await Update_Account_Info(rowData._id, data);
    if (response.code === 200) {
      socket.emit("ad_account_event", {
        notification: response.notification,
      });
      handleCloseModal();
      setUserList((prev) => {
        const updatedUserList = [...prev];
        updatedUserList[indexToInsert] = {
          ...updatedUserList[indexToInsert],
          account_name: response?.ad_account?.account_name,
        };
        return updatedUserList;
      });
      setRowData((prev) => {
        return {
          ...prev,
          account_name: response?.ad_account?.account_name,
        };
      });
    } else {
      enqueueSnackbar(response.message, {
        variant: "error",
      });
    }
    setLoading(false);
  };

  const handleInputsChange = (event) => {
    const { name, value } = event.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  useEffect(() => {
    setInputs({
      account_name: rowData?.account_name,
    });
  }, []);

  return (
    <>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Account Name{" "}
          <Tooltip title="Edit Account Name" placement="top" arrow>
            <EditIcon
              onClick={() => stOpenModal(true)}
              style={{
                fill: "#fff",
                marginLeft: "10px",
                cursor: "pointer",
                fontSize: "20px",
              }}
            />
          </Tooltip>
        </p>

        <p className="mb-0 text-muted text-center text-md-end  col-12 col-md-6 ">
          {rowData?.account_name}
        </p>
      </div>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Business Entity
        </p>
        <p className="mb-0 text-muted text-center text-md-end  col-12 col-md-6">
          {rowData?.business_entity}
        </p>
      </div>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Google Drive Link for Creatives
        </p>
        <p
          className="mb-0 text-muted text-center text-md-end  col-12 col-md-6"
          style={{
            overflowWrap: "anywhere",
          }}
        >
          {rowData?.google_drive_link}
        </p>
      </div>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Email for Ad Account
        </p>
        <p
          className="mb-0 col-12 col-md-6 text-center text-md-start   text-muted text-center text-md-end "
          style={{
            overflowWrap: "anywhere",
          }}
        >
          {rowData?.email}
        </p>
      </div>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Business Address
        </p>
        <p
          className="col-12 col-md-6 mb-0 text-muted text-center text-md-end "
          style={{
            overflowWrap: "anywhere",
          }}
        >
          {rowData?.business_address}
        </p>
      </div>
      <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
        <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
          Timezone
        </p>
        <p className="mb-0 text-muted text-center text-md-end  col-12 col-md-6">
          {rowData?.timezone}
        </p>
      </div>
      {rowData?.type === "facebook" && (
        <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
          <p className="mb-0 col-12 col-md-6 text-center text-md-start  ">
            Profile Link
          </p>
          <p
            className="mb-0 text-muted text-center text-md-end  ps-3 col-12 col-md-6"
            style={{
              overflowWrap: "anywhere",
            }}
          >
            {rowData?.facebook_profile_link}
          </p>
        </div>
      )}
      {rowData?.type === "facebook" && (
        <div className="d-flex flex-wrap border-1 border-bottom border-grey  py-2 justify-content-between align-items-center mt-2 w-100">
          <p className="mb-0 col-12 col-md-6 text-center text-md-start">
            Business Manager ID
          </p>
          <p className="mb-0 text-muted text-center text-md-end  col-12 col-md-6">
            {rowData.business_manager_id}
          </p>
        </div>
      )}
      {rowData?.type === "facebook" && (
        <div className="d-flex flex-wrap border-1 border-bottom border-grey py-2 justify-content-between align-items-center mt-2 w-100">
          <p className="mb-0 text-center text-md-start   col-12 col-md-6">
            Facebook Page Link
          </p>
          <p
            className="mb-0 text-muted text-center text-md-end  text-end col-12 col-md-6"
            style={{
              overflowWrap: "anywhere",
            }}
          >
            {rowData.facebook_page_link}
          </p>
        </div>
      )}
      <Modal open={modal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 555,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Update Account Info
          </Typography>

          <div className="row">
            <div className="col-12">
              <TextField
                required
                InputProps={{
                  readOnly: loading,
                }}
                fullWidth
                label="Account Name"
                variant="outlined"
                className="mb-2"
                margin="normal"
                name="account_name"
                onChange={handleInputsChange}
                value={inputs?.account_name}
              />
            </div>
          </div>

          <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              onClick={() => stOpenModal(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Tooltip
              slots={{
                transition: Fade,
              }}
              slotProps={{
                transition: { timeout: 600 },
              }}
              title={
                !inputs?.account_name
                  ? "You need to fill all the required fields to Update Account Info"
                  : ""
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={!inputs?.account_name || loading}
                >
                  Update
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
